/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import React from 'react';
import { Button, FormGroup, Input } from 'reactstrap';

interface UtrTableSearchProps {
  onChange: (e: React.ChangeEvent<any>) => void;
  handleCancel: () => void;
  value: string;
  filterMessage?: string;
  label?: string;
  acceptMessage?: string;
  showConfirmationButton?: boolean;
}

export const UtrTableSearch = (props: UtrTableSearchProps) => {

  const {
    value,
    onChange,
    handleCancel,
    filterMessage = 'Metrics that match your criteria',
    label = 'Search for an existing metric name',
    acceptMessage = 'Accept changes and go back to the Metric list',
    showConfirmationButton = true
  } = props;

  const code = 'name';
  return (
    <>
      <FormGroup key={code}>
        <Input
          id={code}
          placeholder={label}
          name={code}
          autoComplete='off'
          type={'text'}
          onChange={onChange}
          value={value ?? ''}
        >
        </Input>
      </FormGroup>
      <div className='mt-3 border-top' />
      <h5 className='mt-3 title-container'>
        <span>
          <i className='fa fa-plus mr-2' />{filterMessage}
        </span>
        {
          showConfirmationButton && <SimpleTooltip text={acceptMessage}>
            <Button className='float-end' onClick={handleCancel} outline={true} size='sm'>
              <i className='fa fa-check' />
            </Button>
          </SimpleTooltip>
        }
      </h5>
    </>
  )
}
